import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { RegisterUser } from "../../../redux/authslice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

const Signup = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [signupData, setSignupData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    school_year: "",
    password: "",
  });
  const [errors, setErrors] = useState({});

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const validate = () => {
    const errors = {};

    if (!signupData.first_name.trim()) {
      errors.first_name = "First name required";
    }
    if (!signupData.last_name.trim()) {
      errors.last_name = "Last name required";
    }
    if (!signupData.email.trim()) {
      errors.email = "Email address required";
    } else if (!/\S+@\S+\.\S+/.test(signupData.email)) {
      errors.email = "Email address  invalid";
    }
    if (!signupData.password.trim()) {
      errors.password = "Password required";
    } else if (
      !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%?&^#~_+=-])[A-Za-z\d@$!%?&^#~_+=-]{8,}$/.test(
        signupData.password
      ) ||
      /\*/.test(signupData.password)
    ) {
      errors.password =
        "Password must contain at least 8 characters, including at least one uppercase letter, one lowercase letter, one digit, and one special character (excluding '*')";
    }

    if (!signupData.school_year) {
      errors.school_year = "School year required";
    }
    // if (!signupData.termsAccepted) {
    //   errors.termsAccepted = "You must accept the terms and conditions";
    // }

    return errors;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setSignupData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors)?.length === 0) {
      dispatch(RegisterUser({ dispatch, setSignupData, navigate, signupData }));
    } else {
      setErrors(validationErrors);
    }
  };

  return (
    <div className="login-page-2">
      <p className="accout-p">Sign up for free</p>
      <form onSubmit={handleSubmit}>
        <div className="mar-15">
          <label className="label1" htmlFor="first_name">
            First name
          </label>
          <input
            type="text"
            className="all-input"
            placeholder="Enter first name"
            name="first_name"
            value={signupData.first_name}
            onChange={handleChange}
          />
          {errors.first_name && (
            <p className="error_text">{errors.first_name}</p>
          )}
        </div>
        <div className="mar-15">
          <label className="label1" htmlFor="last name">
            Last name
          </label>
          <input
            type="text"
            className="all-input"
            placeholder="Enter last name"
            name="last_name"
            value={signupData.last_name}
            onChange={handleChange}
          />
          {errors.last_name && <p className="error_text">{errors.last_name}</p>}
        </div>
        <div className="mar-15">
          <label className="label1" htmlFor="email">
            Email address
          </label>
          <input
            type="text"
            className="all-input"
            placeholder="Enter email address"
            name="email"
            value={signupData.email}
            onChange={handleChange}
          />
          {errors.email && <p className="error_text">{errors.email}</p>}
        </div>
        <div className="mar-15" style={{ position: "relative" }}>
          <label className="label1" htmlFor="email">
            Password
          </label>
          <input
            type={showPassword ? "text" : "password"}
            className="all-input"
            placeholder="Enter password"
            name="password"
            value={signupData.password}
            onChange={handleChange}
          />
          <FontAwesomeIcon
            icon={showPassword ? faEyeSlash : faEye}
            className="bag-light-3"
            onClick={togglePasswordVisibility}
          />
          {errors.password && <p className="error_text">{errors.password}</p>}
        </div>
        <div className="mar-15">
          <label className="label1" htmlFor="school_year">
            School year
          </label>
          <select
            className="all-input"
            name="school_year"
            value={signupData.school_year}
            onChange={handleChange}
          >
            <option value="">Select an option</option>
            <option value="Year_7">Year 7</option>
            <option value="Year_8">Year 8</option>
            <option value="Year_9">Year 9</option>
            <option value="Year_10">Year 10</option>
            <option value="Year_11">Year 11</option>
            <option value="Year_12">Year 12</option>
            <option value="Year_13">Year 13</option>
            {/* Add more options as needed */}
          </select>
          {errors.school_year && (
            <p className="error_text">{errors.school_year}</p>
          )}
        </div>
        <div className="mar-15">
          {/* <div className="check-custom">
            <input
              type="checkbox"
              name="termsAccepted"
              checked={signupData.termsAccepted}
              onChange={handleChange}
            />
            <div className="div-check">
              <p className="accept-1">Accept terms and conditions</p>
              <p className="accept-2">
                You agree to our <a href="">Terms of Service</a> and{" "}
                <a href="">Privacy Policy</a>
              </p>
            </div>
          </div> */}
          {/* {errors.termsAccepted && (
            <p className="error">{errors.termsAccepted}</p>
          )} */}
        </div>
        <div className="mar-15">
          <button type="submit" className="login-bt">
            Sign up
          </button>
        </div>
      </form>
      <div className="mar-15">
        <p className="Sign-up-edu">
          Already a student? <Link to="/">Log in here</Link>
        </p>
      </div>
    </div>
  );
};

export default Signup;
